/** §6.1.1 / §EK-D — Amazon marketplace kimlikleri ve bölgesel uç noktalar. */

export const MARKETPLACE_JP = 'A1VC38T7YXB528' as const;
export const MARKETPLACE_US = 'ATVPDKIKX0DER' as const;

export const SPAPI_ENDPOINT_FE = 'https://sellingpartnerapi-fe.amazon.com' as const;
export const SPAPI_ENDPOINT_NA = 'https://sellingpartnerapi-na.amazon.com' as const;
export const SPAPI_ENDPOINT_EU = 'https://sellingpartnerapi-eu.amazon.com' as const;
export const LWA_TOKEN_ENDPOINT = 'https://api.amazon.com/auth/o2/token' as const;

/** LWA access token 1 saat geçerli; Redis'te 3300 sn TTL ile cache'lenir (§6.1.1). */
export const LWA_TOKEN_CACHE_TTL_SECONDS = 3300 as const;

/** Keepa domain kimlikleri (§6.2.1). */
export const KEEPA_DOMAIN_US = 1 as const;
export const KEEPA_DOMAIN_JP = 5 as const;

/** §6.1.5 — bir JSON_LISTINGS_FEED mesajında en fazla bu kadar kayıt olabilir. */
export const FEED_MAX_RECORDS = 25_000 as const;
/** §6.1.5 — 5 dakikada en fazla bu kadar feed gönderilebilir. */
export const FEED_MAX_PER_WINDOW = 5 as const;
export const FEED_WINDOW_SECONDS = 300 as const;

/** §6.2.1 — Keepa tek istekte en fazla bu kadar ASIN kabul eder. */
export const KEEPA_MAX_ASINS_PER_REQUEST = 100 as const;

/** §6.1.2 — Product Pricing toplu uçları tek istekte 20 ASIN alır. */
export const SPAPI_MAX_ASINS_PER_BATCH = 20 as const;

/** §13.1 — tek aramada en fazla bu kadar ASIN işlenebilir. */
export const MAX_ASINS_PER_SEARCH = 100_000 as const;
/** §13.7 — tek seferde en fazla bu kadar ürün silinebilir. */
export const MAX_ASINS_PER_DELETE = 50_000 as const;
/** §14.1 — yasaklı liste kayıt üst sınırı. */
export const MAX_BLACKLIST_ENTRIES = 225_000 as const;

/** §15.3.5 — bu sayının üstündeki geri alınamaz işlemlerde "ONAYLIYORUM" yazılması istenir. */
export const TYPED_CONFIRMATION_THRESHOLD = 1_000 as const;

/** Amazon Japonya'nın kendi satıcı kimliği — rakip filtrelerinde kullanılır (§12.2). */
export const AMAZON_JP_SELLER_ID = 'AN1VRQENFRJN5' as const;

/** §7.10.1 — JPY kuruşsuzdur; para değerleri tam sayı tutulur. */
export const JPY_DECIMAL_PLACES = 0 as const;
export const USD_DECIMAL_PLACES = 2 as const;
